<!-- CONSULTAS → UTILIDAD (UTL-17). Lo recibido en cuentas CT, lo retornado en los cierres y la utilidad. -->
<div class="flex flex-col gap-[20px]">

  <section class="kb-card">
    <div class="kb-card-header">
      <div>
        <h2 class="kb-card-title flex items-center gap-2"><i class="fas fa-chart-line text-muted-foreground" aria-hidden="true"></i>Utilidad de CrediTotal</h2>
        <p class="kb-card-desc">Lo que entró a las cuentas CT, lo que se retornó a los comercios en los cierres y lo que queda. Solo lectura<ng-container *ngIf="r?.foto_en"> · foto más antigua del {{ r.foto_en | date:'dd/MM/yy HH:mm' }}</ng-container>.</p>
      </div>
    </div>
    <div class="flex flex-col gap-[16px] px-[24px] py-[20px]">
      <div class="flex flex-wrap gap-2" role="group" aria-label="Atajos de rango">
        <button type="button" class="kb-btn kb-btn-sm" [ngClass]="atajoActivo === 'hoy' ? 'kb-btn-primary !bg-foreground !text-background' : 'kb-btn-outline'" [attr.aria-pressed]="atajoActivo === 'hoy'" (click)="atajo('hoy')">Hoy</button>
        <button type="button" class="kb-btn kb-btn-sm" [ngClass]="atajoActivo === 'ayer' ? 'kb-btn-primary !bg-foreground !text-background' : 'kb-btn-outline'" [attr.aria-pressed]="atajoActivo === 'ayer'" (click)="atajo('ayer')">Ayer</button>
        <button type="button" class="kb-btn kb-btn-sm" [ngClass]="atajoActivo === '7dias' ? 'kb-btn-primary !bg-foreground !text-background' : 'kb-btn-outline'" [attr.aria-pressed]="atajoActivo === '7dias'" (click)="atajo('7dias')">7 días</button>
        <button type="button" class="kb-btn kb-btn-sm" [ngClass]="atajoActivo === 'mes' ? 'kb-btn-primary !bg-foreground !text-background' : 'kb-btn-outline'" [attr.aria-pressed]="atajoActivo === 'mes'" (click)="atajo('mes')">Este mes</button>
      </div>
      <div class="flex flex-col sm:flex-row sm:flex-wrap sm:items-end gap-3">
        <label class="kb-label" for="utDesde">Desde
          <input type="date" class="kb-input sm:!w-[170px]" id="utDesde" [(ngModel)]="f.desde" (change)="buscar()">
        </label>
        <label class="kb-label" for="utHasta">Hasta
          <input type="date" class="kb-input sm:!w-[170px]" id="utHasta" [(ngModel)]="f.hasta" (change)="buscar()">
        </label>
        <label class="kb-label" for="utComercio">Comercio
          <select class="kb-select sm:!w-[200px]" id="utComercio" [(ngModel)]="f.comercio" (change)="buscar()">
            <option value="">Todos los comercios</option>
            <option *ngFor="let c of comercios" [value]="c">{{ c }}</option>
          </select>
        </label>
        <label class="kb-label" for="utCuenta">Cuenta receptora
          <select class="kb-select sm:!w-[280px]" id="utCuenta" [(ngModel)]="f.cuenta" (change)="buscar()">
            <option value="">Todas las cuentas CT</option>
            <option *ngFor="let c of cuentas" [value]="c.id">{{ c.nombre }}</option>
          </select>
        </label>
      </div>
      <div class="kb-aviso kb-aviso-peligro" *ngIf="error" role="alert">
        <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i><div><p class="m-0">{{ error }}</p></div>
      </div>
      <p class="kb-hint" *ngIf="cargando && !r">Leyendo la utilidad…</p>
      <p class="kb-hint" *ngIf="cargando && r">Actualizando…</p>
    </div>
  </section>

  <div class="kb-empty" *ngIf="r && !cargando && !error && !hayRecibido">
    <span class="kb-empty-icono"><i class="fas fa-inbox" aria-hidden="true"></i></span>
    <p class="kb-empty-titulo">No entró dinero a cuentas CT en ese rango</p>
    <p class="kb-empty-texto">Prueba con otro rango de fechas o con todas las cuentas.</p>
  </div>

  <ng-container *ngIf="r && hayRecibido">

    <!-- Las cuatro tarjetas: Bs grande, USD pequeño debajo -->
    <section class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4" aria-label="Resumen">
      <div class="kb-card p-[18px] flex flex-col gap-1.5">
        <span class="text-sm text-muted-foreground">Recibido en cuentas CT</span>
        <span class="text-[26px] font-bold tabular-nums text-foreground">{{ fb(r.resumen.recibido.bs) }}</span>
        <span class="text-xs text-muted-foreground tabular-nums">{{ fu(r.resumen.recibido.usd) }} · {{ r.resumen.recibido.n | number:'1.0-0':'es' }} pagos</span>
      </div>
      <div class="kb-card p-[18px] flex flex-col gap-1.5">
        <span class="text-sm text-muted-foreground">Retornado en cierres</span>
        <span class="text-[26px] font-bold tabular-nums text-foreground">{{ fb(r.resumen.liquidado.retornado_bs) }}</span>
        <span class="text-xs text-muted-foreground tabular-nums">{{ fu(r.resumen.liquidado.retornado_usd) }} · {{ r.resumen.liquidado.lineas | number:'1.0-0':'es' }} líneas</span>
      </div>
      <div class="kb-card p-[18px] flex flex-col gap-1.5 !bg-emerald-50 !border-emerald-200 dark:!bg-emerald-500/10 dark:!border-emerald-500/30">
        <span class="text-sm font-medium text-emerald-800 dark:text-emerald-300">Utilidad CT</span>
        <span class="text-[26px] font-bold tabular-nums text-emerald-900 dark:text-emerald-200">{{ fb(r.resumen.utilidad.bs) }}</span>
        <span class="text-xs text-emerald-800 dark:text-emerald-300 tabular-nums">{{ fu(r.resumen.utilidad.usd) }} · margen {{ r.resumen.margen_pct | number:'1.2-2':'es' }} % de lo recibido</span>
      </div>
      <div class="kb-card p-[18px] flex flex-col gap-1.5">
        <span class="text-sm text-muted-foreground">Sin aplicar</span>
        <span class="text-[26px] font-bold tabular-nums text-foreground">{{ fb(r.resumen.sin_aplicar.bs) }}</span>
        <span class="text-xs text-muted-foreground tabular-nums">{{ fu(r.resumen.sin_aplicar.usd) }} · pagos que aún no se aplican a una cuota o fee</span>
      </div>
    </section>

    <!-- Cinta de cuadre -->
    <div class="kb-cinta kb-cinta-info" *ngIf="cuadra" role="status">
      <i class="fas fa-check-circle kb-cinta-icono" aria-hidden="true"></i>
      <span><strong>Recibido = a cuotas + fees + sin aplicar.</strong> {{ fu(r.resumen.recibido.usd) }} = {{ fu(r.resumen.a_cuotas.usd) }} + {{ fu(r.resumen.fees.usd) }} + {{ fu(r.resumen.sin_aplicar.usd) }} (USD, al centavo).</span>
    </div>
    <div class="kb-cinta" *ngIf="!cuadra" role="note">
      <i class="fas fa-info-circle kb-cinta-icono" aria-hidden="true"></i>
      <span><strong>Recibido = a cuotas + fees + sin aplicar no cuadra en este rango.</strong> {{ fu(r.resumen.recibido.usd) }} frente a {{ fu(r.resumen.a_cuotas.usd) }} + {{ fu(r.resumen.fees.usd) }} + {{ fu(r.resumen.sin_aplicar.usd) }}. Avisa a sistemas.</span>
    </div>

    <!-- A dónde fue lo recibido -->
    <section class="kb-card">
      <div class="kb-card-header"><h2 class="kb-card-title">A dónde fue lo recibido</h2></div>
      <div class="flex flex-col gap-3 px-[24px] py-[20px]">
        <div class="flex h-7 overflow-hidden rounded-md bg-muted" role="img"
             [attr.aria-label]="'Barra: ' + destino[0].pct + ' % a cuotas, ' + destino[1].pct + ' % fees, ' + destino[2].pct + ' % sin aplicar'">
          <div *ngFor="let s of destino" [ngClass]="s.clase" [style.width.%]="s.pct"></div>
        </div>
        <div class="flex flex-wrap gap-x-5 gap-y-2 text-sm text-muted-foreground">
          <span *ngFor="let s of destino" class="inline-flex items-center gap-2"><span class="inline-block h-3 w-3 rounded-sm" [ngClass]="s.clase"></span>{{ s.texto }} {{ s.pct | number:'1.1-1':'es' }} %</span>
        </div>
      </div>
    </section>

    <!-- Gráfico: por hora (rango de hasta 7 días) o por día -->
    <section class="kb-card">
      <div class="kb-card-header">
        <div>
          <h2 class="kb-card-title">{{ porHora ? 'Entrada de dinero, hora por hora' : 'Entrada de dinero, día por día' }}</h2>
          <p class="kb-card-desc">Bolívares recibidos en cuentas CT; abajo lo que fue a cuotas y arriba los fees. Pasa el cursor sobre una barra para ver el detalle.</p>
        </div>
      </div>
      <div class="flex flex-col gap-3 px-[24px] py-[20px]">
        <div class="overflow-x-auto">
          <div class="min-w-[720px]">
            <svg viewBox="0 0 1240 280" width="100%" role="img" class="block"
                 [attr.aria-label]="pico ? ('Bolívares recibidos ' + (porHora ? 'por hora' : 'por día') + ', ' + pico.texto) : 'Bolívares recibidos'">
              <g *ngFor="let e of ejeY">
                <line x1="56" x2="1228" [attr.y1]="e.y" [attr.y2]="e.y" stroke="#ececec"></line>
                <text x="48" [attr.y]="e.y + 4" text-anchor="end" font-size="11" fill="#737373">{{ e.texto }}</text>
              </g>
              <g *ngFor="let b of barras">
                <title>{{ b.titulo }}</title>
                <rect [attr.x]="b.xt" y="30" [attr.width]="b.wt" height="210" fill="transparent"></rect>
                <rect *ngIf="b.hC > 0" [attr.x]="b.x" [attr.y]="b.yC" [attr.width]="b.w" [attr.height]="b.hC" fill="#404040"></rect>
                <rect *ngIf="b.hF > 0" [attr.x]="b.x" [attr.y]="b.yF" [attr.width]="b.w" [attr.height]="b.hF" fill="#16a34a"></rect>
              </g>
              <text *ngFor="let e of ejeX" [attr.x]="e.x" y="260" text-anchor="middle" font-size="11" fill="#737373">{{ e.texto }}</text>
              <text *ngIf="pico" [attr.x]="pico.x" [attr.y]="pico.y" text-anchor="middle" font-size="11" font-weight="600" fill="#0a0a0a">{{ pico.texto }}</text>
            </svg>
          </div>
        </div>
        <div class="flex flex-wrap gap-x-5 gap-y-2 text-sm text-muted-foreground">
          <span class="inline-flex items-center gap-2"><span class="inline-block h-3 w-3 rounded-sm bg-[#404040]"></span>A cuotas</span>
          <span class="inline-flex items-center gap-2"><span class="inline-block h-3 w-3 rounded-sm bg-[#16a34a]"></span>Fees (utilidad)</span>
        </div>
      </div>
    </section>

    <!-- Por cuenta receptora -->
    <section class="kb-card">
      <div class="kb-card-header">
        <div>
          <h2 class="kb-card-title">Por cuenta receptora</h2>
          <p class="kb-card-desc">Desde la cuenta del pago. Un clic en una fila filtra toda la vista por esa cuenta; otro clic la suelta.</p>
        </div>
      </div>
      <div class="kb-table-envoltorio">
        <table class="kb-table">
          <thead class="kb-thead"><tr>
            <th class="kb-th">Cuenta</th><th class="kb-th kb-th-num">Pagos</th><th class="kb-th kb-th-num">Recibido</th>
            <th class="kb-th kb-th-num">A cuotas</th><th class="kb-th kb-th-num">Fees</th><th class="kb-th kb-th-num">% del total</th>
          </tr></thead>
          <tbody>
            <tr class="kb-tr cursor-pointer" *ngFor="let c of r.por_cuenta" (click)="elegirCuenta(c.id)" (keydown.enter)="elegirCuenta(c.id)" tabindex="0"
                [class.bg-muted]="f.cuenta === c.id">
              <td class="kb-td">{{ c.nombre }}<span class="kb-badge kb-badge-neutro ml-2" *ngIf="f.cuenta === c.id">filtrando</span></td>
              <td class="kb-td kb-td-num">{{ c.n | number:'1.0-0':'es' }}</td>
              <td class="kb-td kb-td-num font-semibold">{{ fb(c.bs) }}<span class="kb-td-sub block">{{ fu(c.usd) }}</span></td>
              <td class="kb-td kb-td-num">{{ fb(bsFila(c, c.cuotas_usd)) }}<span class="kb-td-sub block">{{ fu(c.cuotas_usd) }}</span></td>
              <td class="kb-td kb-td-num">{{ fb(bsFila(c, c.fees_usd)) }}<span class="kb-td-sub block">{{ fu(c.fees_usd) }}</span></td>
              <td class="kb-td kb-td-num">{{ c.pct | number:'1.1-1':'es' }} %</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- Utilidad por concepto -->
    <section class="kb-card">
      <div class="kb-card-header"><h2 class="kb-card-title">Utilidad por concepto</h2></div>
      <div class="kb-table-envoltorio">
        <table class="kb-table">
          <thead class="kb-thead"><tr>
            <th class="kb-th">Concepto</th><th class="kb-th kb-th-num">Casos</th><th class="kb-th kb-th-num">Utilidad</th><th class="kb-th kb-th-num">Peso</th>
          </tr></thead>
          <tbody>
            <tr class="kb-tr" *ngFor="let c of conceptos">
              <td class="kb-td">{{ c.nombre }}</td>
              <td class="kb-td kb-td-num">{{ c.n | number:'1.0-0':'es' }}</td>
              <td class="kb-td kb-td-num font-semibold">{{ fb(c.bs) }}<span class="kb-td-sub block">{{ fu(c.usd) }}</span></td>
              <td class="kb-td kb-td-num">{{ c.peso | number:'1.1-1':'es' }} %</td>
            </tr>
            <tr class="kb-tr">
              <td class="kb-td font-semibold">Utilidad CT</td><td class="kb-td"></td>
              <td class="kb-td kb-td-num font-semibold">{{ fb(r.resumen.utilidad.bs) }}<span class="kb-td-sub block">{{ fu(r.resumen.utilidad.usd) }}</span></td>
              <td class="kb-td kb-td-num font-semibold">100 %</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- Por día -->
    <section class="kb-card">
      <div class="kb-card-header"><h2 class="kb-card-title">Por día</h2></div>
      <div class="kb-table-envoltorio">
        <table class="kb-table">
          <thead class="kb-thead"><tr>
            <th class="kb-th">Día</th><th class="kb-th kb-th-num">Recibido</th><th class="kb-th kb-th-num">A cuotas</th><th class="kb-th kb-th-num">Fees</th>
            <th class="kb-th kb-th-num">Retornado</th><th class="kb-th kb-th-num">Comisión + uso</th><th class="kb-th kb-th-num">Utilidad</th><th class="kb-th kb-th-num">Margen</th>
          </tr></thead>
          <tbody>
            <tr class="kb-tr" *ngFor="let d of r.por_dia">
              <td class="kb-td tabular-nums">{{ d.dia }}<span class="kb-td-sub block">{{ d.origen === 'foto' ? 'foto' : 'en vivo' }}</span></td>
              <td class="kb-td kb-td-num font-semibold">{{ fb(d.bs) }}<span class="kb-td-sub block">{{ fu(d.usd) }} · {{ d.n | number:'1.0-0':'es' }} pagos</span></td>
              <td class="kb-td kb-td-num">{{ fb(bsFila(d, d.cuotas_usd)) }}<span class="kb-td-sub block">{{ fu(d.cuotas_usd) }}</span></td>
              <td class="kb-td kb-td-num">{{ fb(bsFila(d, d.fees_usd)) }}<span class="kb-td-sub block">{{ fu(d.fees_usd) }}</span></td>
              <td class="kb-td kb-td-num">{{ fb(bsT(d.retornado_usd)) }}<span class="kb-td-sub block">{{ fu(d.retornado_usd) }}</span></td>
              <td class="kb-td kb-td-num">{{ fb(bsT(d.comision_usd + d.uso_usd)) }}<span class="kb-td-sub block">{{ fu(d.comision_usd + d.uso_usd) }}</span></td>
              <td class="kb-td kb-td-num font-semibold">{{ fb(bsT(d.utilidad_usd)) }}<span class="kb-td-sub block">{{ fu(d.utilidad_usd) }}</span></td>
              <td class="kb-td kb-td-num">{{ margen(d) | number:'1.1-1':'es' }} %</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="flex flex-col gap-1 px-[24px] py-[14px]">
        <p class="kb-hint m-0">Recibido se cuenta por el día en que entró el pago; lo retornado y la comisión, por el día del cierre que los liquidó.</p>
        <p class="kb-hint m-0" *ngIf="r.dias_en_vivo?.length">Días en vivo: {{ r.dias_en_vivo.join(', ') }} (todavía no tienen foto guardada).</p>
      </div>
    </section>

  </ng-container>
</div>
